import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import styles from './index.module.scss';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCarpoolById, getDeliveryById } from '@/api/car';
import OrderDialogCar, { OrderDialogOrder, OrderDialogMode } from '@/components/OrderDialogCar/OrderDialogCar';
import { OrderItem } from '@/pages/YourTownloop/Subroute/PostOrders/order';
import dayjs, { Dayjs } from 'dayjs';
// interface OrderItem {
//   delivery_order_id?: string;                      // 订单ID
//   carpool_order_id?: string;                      // 订单ID
//   departure_date: string;            // 出发时间
//   acceptable_advance_delay: string;       // 可接受的提前量（分钟/小时，按业务定义）
//   stopovers: string;               // 经停数量
//   starting_point_state: string;               // 出发州
//   starting_point_city: string;                // 出发城市
//   starting_point_address: string;             // 出发详细地址
//   destination_point_state: string;                 // 到达州
//   destination_point_city: string;                  // 到达城市
//   destination_point_address: string;               // 到达详细地址
//   seats_needed: string;             // 需要座位数
//   has_luggage: boolean;                // 是否有行李
//   fixed_price: string;              // 固定价格
//   bidding_price: string;                 // 出价
//   service_requirements: string;     // 服务要求
//   notes: string;
//   distance: string;                   // 备注




//   // Delivery specific fields
//   pickup_time?: string;              // 取件时间
//   expected_delivery_time?: string;   // 期望送达时间
//   item_description?: string;         // 物品描述
//   quantity?: string;                 // 数量
//   package_size?: string;             // 包裹尺寸
//   package_weight?: string;                    // 备注
// }

const CarpoolServiceDetail: React.FC = () => {
  const { t } = useTranslation();

  // 辅助函数：格式化日期
  const formatDate = (date: string | dayjs.Dayjs | undefined): string => {
    if (!date) return '';
    if (typeof date === 'string') return date;
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
  };

  const params = useParams(); // 获取URL参数

  const [searchParams] = useSearchParams();

  const [detail, setDetail] = useState<OrderItem>({
    carpool_order_id: undefined,
    departure_date: '',
    acceptable_advance_delay: 0,
    stopovers: 0,
    starting_point_state: '',
    starting_point_city: '',
    starting_point_address: '',
    destination_point_state: '',
    destination_point_city: '',
    destination_point_address: '',
    seats_needed: 0,
    has_luggage: true,
    final_price: 0,
    budget_price: 0,
    service_requirements: '',
    notes: '',
    starting_point_latitude: 0,
    starting_point_longitude: 0,
    destination_point_latitude: 0,
    destination_point_longitude: 0,
    distance: 0,
    bid_record_count: 0,
    order_status: 0,
    pickup_time: '',
    expected_delivery_time: '',
    item_description: '',
    quantity: 0,
    package_size: '',
    package_weight: '',
    carpool_order_status: 0,
    delivery_order_id: undefined,
  });

  const [mapUrl, setMapUrl] = useState<string>('')

  // 竞价和一口价弹窗
  const [dialogMode, setDialogMode] = useState<OrderDialogMode>('bidding');
  const [dialogOpen, setDialogOpen] = useState(false);

  //是否是送货
  const [isDelivery, setIsDelivery] = useState<boolean>(false);

  const openDialog = (mode: OrderDialogMode) => {
    setDialogMode(mode);

    setDialogOpen(true);
  };
  //提交竞价
  const handleConfirm = () => {
    setDialogOpen(false);
  };
  // 竞价和一口价弹窗

  useEffect(() => {
    const start = detail.starting_point_address + ',' + detail.starting_point_city + ',' + detail.starting_point_state;
    const destination = detail.destination_point_address + ',' + detail.destination_point_city + ',' + detail.destination_point_state;
    //debugger
    const mapQuery = encodeURIComponent(`${start} to ${destination}`);
    const mapUrl2 = `https://www.google.com/maps?output=embed&q=${mapQuery}`;

    setMapUrl(mapUrl2);
  }, [detail])



  useEffect(() => {
    if (params.id) {
      console.log('typetypetypetype', searchParams.get('type'));

      if (searchParams.get('type') === 'delivery') {
        setIsDelivery(true);
        getDeliveryById(params.id).then((res) => {
          setDetail(res.data);
        })
      } else {
        getCarpoolById({ carpool_order_id: params.id }).then((res) => {
          setDetail(res.data);
        })
      }
    }

  }, [])



  return (
    <div className={styles['detail-page']}>
      <div className={styles['info-card']}>


        <ul className={styles['route-list']}>
          <li>
            <span className={styles['label-strong']}>{t('carpoolServiceDetail.startingPoint')}:</span>
            <span className={styles['text']}>{detail.starting_point_address + ',' + detail.starting_point_city + ',' + detail.starting_point_state}</span>
          </li>
          <li>
            <span className={styles['label-strong']}>{t('carpoolServiceDetail.destination')}:</span>
            <span className={styles['text']}>{detail.destination_point_address + ',' + detail.destination_point_city + ',' + detail.destination_point_state}</span>
          </li>
        </ul>

        <div className={styles['miles-row']}>
          <span className={styles['dot']}></span>
          {detail.distance || 2.5} {t('carpoolServiceDetail.milesFromYou')}
        </div>

        <div className={styles['divider']} />

        {
          !isDelivery && (
            <>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.departure')}:</span>
                <span className={styles['value']}>{formatDate(detail.departure_date)}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.seatsNeeded')}:</span>
                <span className={styles['value']}>{detail.seats_needed} {t('carpoolServiceDetail.people')}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.luggage')}:</span>
                <span className={styles['value']}>{detail.has_luggage ? t('carpoolServiceDetail.hasLuggage') : t('carpoolServiceDetail.noLuggage')}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.serviceRequirements')}:</span>
                <span className={styles['value']}>{detail.service_requirements}</span>
              </div>

              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.notes')}:</span>
                <span className={styles['value']}>{detail.notes}</span>
              </div>
            </>
          )
        }

        {
          isDelivery&&(
            <>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.pickupTime')}:</span>
                <span className={styles['value']}>{formatDate(detail.pickup_time)}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.expectedDeliveryTime')}:</span>
                <span className={styles['value']}>{formatDate(detail.expected_delivery_time)}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.itemDescription')}:</span>
                <span className={styles['value']}>{detail.item_description}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.quantity')}:</span>
                <span className={styles['value']}>{detail.quantity}</span>
              </div>

              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.packageSize')}:</span>
                <span className={styles['value']}>{detail.package_size}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.packageWeight')}:</span>
                <span className={styles['value']}>{detail.package_weight}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>{t('carpoolServiceDetail.notes')}:</span>
                <span className={styles['value']}>{detail.notes}</span>
              </div>
            </>
          )
        }
        <div className={styles['price-row']}>
          <span className={styles['price-label']}>{t('carpoolServiceDetail.fixedPrice')}:</span>
          <span className={styles['price']}>${detail.budget_price}</span>
        </div>

        <div className={styles['actions']}>
          <Button
            className={styles['btn-outline']}
            onClick={() => openDialog('bidding')}
          >{t('carpoolServiceDetail.bidding')}</Button>
          <Button
            className={styles['btn-primary']}
            onClick={() => openDialog('fixed')}
          >{t('carpoolServiceDetail.fixedPrice')}</Button>
        </div>
      </div>

      <div className={styles['map-card']}>
        <iframe
          className={styles['map-iframe']}
          src={mapUrl}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={t('carpoolServiceDetail.routeMap')}
        />
      </div>

      {detail && (
        <OrderDialogCar
          open={dialogOpen}
          mode={dialogMode}
          order={detail}
          onCancel={() => setDialogOpen(false)}
          onConfirm={() => setDialogOpen(false)}
        />
      )}
    </div>
  );
};

export default CarpoolServiceDetail; 